/* eslint-disable multiline-ternary */
import React, { useEffect, useState } from 'react'
import { AnimateSharedLayout, motion } from 'framer-motion'
import {
  animationAppTransitions,
  animationAppVariants
} from '../component/Helpers/pageAnimation'
import { useGlobalState } from '../providers/GlobalState'
import SimulationsButton from '../component/SimulationsButton'
import EyeAnatomyEdit from '../component/EyeAnatomyEdit'
import { useEditMode } from '../providers/EditMode'

type Option = { name: string; url: string; active?: boolean }

const EyeAnatomy: React.FC = () => {
  const { anatomyEye } = useGlobalState()
  const { editMode } = useEditMode()
  const [url, setUrl] = useState<string>('')
  const [options, setOptions] = useState<Option[]>([])

  const handleChange = (url: string) => {
    setUrl(url)
  }

  useEffect(() => {
    if (anatomyEye) {
      setUrl(anatomyEye.thumb || '')
      setOptions([
        {
          name: 'Informativo',
          url: anatomyEye.thumb,
          active: !!anatomyEye.thumb
        },
        {
          name: '3D',
          url: anatomyEye.iframe || '',
          active: !!anatomyEye.iframe
        }
      ])
    }
  }, [anatomyEye])

  const Page: React.FC = () => {
    return (
      <motion.div
        initial="initial"
        animate="in"
        exit="out"
        variants={animationAppVariants}
        transition={animationAppTransitions}
      >
        {url === anatomyEye?.iframe ? (
          <div
            style={{
              position: 'relative',
              background:
                'linear-gradient(180deg, #666666 0%, #666666 143.29%)',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100vh',
              margin: 'auto',
              overflow: 'hidden'
            }}
          >
            <div
              style={{
                position: 'relative',
                overflow: 'hidden',
                width: '100%',
                paddingTop:
                  '56.25%' /* 16:9 Aspect Ratio (divide 9 by 16 = 0.5625) */
              }}
            >
              <iframe
                src={url}
                title={anatomyEye?.name}
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  bottom: 0,
                  right: 0,
                  width: '100%',
                  height: '100%'
                }}
              />
            </div>
          </div>
        ) : (
          <div
            style={{
              height: '100vh',
              overflowY: 'auto'
            }}
          >
            <img src={url} alt={anatomyEye?.name} style={{ width: '100%' }} />
          </div>
        )}
      </motion.div>
    )
  }

  return (
    <AnimateSharedLayout>
      <Page />
      {editMode && <EyeAnatomyEdit />}
      {anatomyEye && options[0] && (
        <SimulationsButton
          handleScenarioChange={handleChange}
          options={options}
          activeUrl={url}
        />
      )}
    </AnimateSharedLayout>
  )
}

export default EyeAnatomy
